import { useEffect, useState } from "react";
import $ from "jquery";
import image8 from "assets/hm_service_image/MHSD_footer.png";
import image9 from "assets/hm_service_image/MHSDmb.png";
import image10 from "assets/hm_service_image/footer-introduce-step.png";
import { getDetailPreOrderHashcode } from "services/pre-order.service";
import HomeBannerPromotion from "components/shared/HomeBannerPromotion";
import { HomeStyled } from "styles/homeStyled";
import { notification, Modal } from "antd";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
// import homebn from "assets/hm_service_image/bn-doi.png";
import { PRODUCTS } from "config/products";

function OrderPage() {
    const [loading, setLoading] = useState(true);
    const [preOrder, setPreOrder] = useState({});
    const { pre_order_id } = useParams();

    useEffect(() => {
        const getData = async () => {
            const res = await getDetailPreOrderHashcode(pre_order_id);
            if (!res?.data) return res;

            let product = PRODUCTS.find((x) => +x.productId === +res.data.PRODUCTID);

            if (product) {
                res.data.productSelect = {
                    ...product,
                    // capacityName: CAPACITYS.find((x) => x.capacityKey === product.capacityKey)?.name,
                    // colorName: COLORS.find((x) => x.colorKey === product.colorKey)?.colorName,
                };
            }
            return res;
        };

        const loadPreOrder = async () => {
            setLoading(true);
            try {
                const res = await getData();
                if (!res?.data) return;
                setPreOrder(res.data);
                setLoading(false);
            } catch (error) {
                notification.error({
                    message: error?.message ?? "Không có dữ liệu đơn hàng",
                });
            } finally {
                setLoading(false);
            }
        };
        loadPreOrder();
    }, [pre_order_id]);

    const createdDate = new Date(preOrder?.CREATEDDATE);
    const startOfSep2026 = new Date('2026-08-01T00:00:00');

    const isBeforeSep2026 = createdDate < startOfSep2026;

    return (
        <HomeStyled>
            <div className="pre-order-page">
                <div className="page pre-home-page">
                    <div className="home-banner home-banner-rp">
                        <div className="content-home-banner bn-big">
                            {/* <img src={homebn} alt="" width="100%" className="" /> */}
                            {/* <img src={homebnmb} alt="" width="100%" className="f-mb" /> */}
                            <HomeBannerPromotion />
                        </div>
                    </div>

                    <div className="container-ordercomplete">
                        {/* <h3>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M4.03498 11.573C4.49698 9.264 4.72798 8.11 5.55698 7.43C6.38698 6.75 7.56398 6.75 9.91898 6.75H14.081C16.436 6.75 17.613 6.75 18.442 7.43C19.272 8.11 19.502 9.264 19.965 11.573L20.565 14.573C21.229 17.893 21.561 19.553 20.661 20.652C19.761 21.75 18.067 21.75 14.681 21.75H9.31998C5.93398 21.75 4.23998 21.75 3.33998 20.652C2.43998 19.554 2.77198 17.894 3.43598 14.573L4.03498 11.573Z" fill="#049844" />
                                <path d="M15 10.75C15.5523 10.75 16 10.3023 16 9.75C16 9.19772 15.5523 8.75 15 8.75C14.4477 8.75 14 9.19772 14 9.75C14 10.3023 14.4477 10.75 15 10.75Z" fill="#5EBF23" />
                                <path d="M9 10.75C9.55228 10.75 10 10.3023 10 9.75C10 9.19772 9.55228 8.75 9 8.75C8.44772 8.75 8 9.19772 8 9.75C8 10.3023 8.44772 10.75 9 10.75Z" fill="#5EBF23" />
                                <path d="M9.75 5.75C9.75 5.15326 9.98705 4.58097 10.409 4.15901C10.831 3.73705 11.4033 3.5 12 3.5C12.5967 3.5 13.169 3.73705 13.591 4.15901C14.0129 4.58097 14.25 5.15326 14.25 5.75V6.75H14.681C15.058 6.75 15.414 6.75 15.75 6.752V5.75C15.75 4.75544 15.3549 3.80161 14.6517 3.09835C13.9484 2.39509 12.9946 2 12 2C11.0054 2 10.0516 2.39509 9.34835 3.09835C8.64509 3.80161 8.25 4.75544 8.25 5.75V6.752C8.586 6.75 8.942 6.75 9.319 6.75H9.75V5.75Z" fill="#5EBF23" />
                            </svg>
                            Thông tin đặt hàng
                        </h3>
                        <div className="info-ordercomplete">
                            <InformationCommon preOrder={preOrder} />
                            <div className="products">
                                <ul>
                                    <li>
                                        <strong>Sản phẩm: </strong>
                                        <span>{preOrder?.productSelect?.productName}</span>
                                    </li>
                                    {preOrder.ATTRIBUTES?.map((attr, index) => (
                                        <li key={index}>
                                            <strong>{attr.ATTRIBUTENAME}:</strong> {attr.ATTRIBUTEVALUES}
                                        </li>
                                    ))}
                                    <li><strong>Số lượng: </strong>1</li>
                                </ul>
                            </div>
                        </div> */}
                        <div className="all-btn-stutus">
                            {!isBeforeSep2026 &&
                                <div className="all-btn-stutus">
                                    {loading ? (
                                        <p style={{ fontSize: "16px", color: "white" }}>Đang tải dữ liệu...</p>
                                    ) : (
                                        <>
                                            {/* <a className="btn-stutus change" href={`/change-product/${pre_order_id}`}>Đổi sang sản phẩm tương tự</a> */}
                                            <a className="btn-stutus wait" href={`/waiting-product/${pre_order_id}`}>
                                                Lấy hàng ở đợt tiếp theo
                                                {/* <span>(dự kiến 03/10/2025)</span> */}
                                            </a>
                                            <a className="btn-stutus cancel" href={`/refund/${pre_order_id}`}>Phương án khác</a>
                                        </>
                                    )}
                                </div>
                            }
                        </div>

                        <div className="note-hc">*Quý khách cần thực hiện đổi sản phẩm hoặc yêu cầu hoàn cọc trong vòng 24h Kể từ khi nhận được thông báo</div>
                    </div>


                    <div className="footer-introduce desktop">
                        <img src={image8} alt="" width="100%" />
                    </div>

                    <div className="footer-introduce mobile">
                        <h3 className="tt-introduce">Tại sao nên mua hàng tại ShopDunk</h3>
                        <div className="d-scroll">
                            <img src={image9} alt="" width="1328px" />
                        </div>
                        {/* <h3 className="tt-introduce">Cách sở hữu iPhone 16 Pro Max sớm nhất, giá tốt nhất</h3>
                        <div className="d-scroll">
                            <img src={image10} alt="" width="1032px" />
                        </div> */}
                    </div>
                </div>
            </div>
        </HomeStyled>
    );
}

export default OrderPage;
